// Load speperate modules
import { Radar, mixins } from 'vue-chartjs'

export default Radar.extend({
  mixins: [mixins.reactiveProp],
  props: ['chartData', 'options'],
  mounted () {
    this.renderChart(this.chartData, this.options)
  }
})



// WEBPACK FOOTER //
// ./src/charts/Radar.js